import { render, staticRenderFns } from "./ListaCitasview.vue?vue&type=template&id=6137a998&scoped=true"
import script from "./ListaCitasview.vue?vue&type=script&lang=js"
export * from "./ListaCitasview.vue?vue&type=script&lang=js"
import style0 from "./ListaCitasview.vue?vue&type=style&index=0&id=6137a998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6137a998",
  null
  
)

export default component.exports